import React from "react";
import { Container, Title, Button } from "@bsf/force-ui";
import { Zap } from "lucide-react";
import { __ } from "@wordpress/i18n";
import { Link, history } from '../../router/index';
import { routes } from "../../admin/settings/routes";

const ElementsFont = () => {

     const settings = [
        { label: 'Google Manager', tab: 4 },
    ];

        const handleTabRedirect = (e, tab) => {
        e.preventDefault();
        const params = new URLSearchParams(window.location.search);
        params.set('tab', tab);
        const query = params.toString();
        history.push(`${window.location.pathname}${query ? '?' + query : ''}#${routes.settings.path}`);
    };
    
    return (
        <Container
            align="center"
            className="bg-background-primary border-[0.5px] border-subtle rounded-xl shadow-sm mb-6 p-6 flex flex-col lg:flex-col"
            containerType="flex"
            direction="row"
            justify="between"
            gap="sm"
        >
            <Container.Item
                shrink={1}
                className="md:mt-0 mt-4">
                <img
                    src={`${uavcSettingsData.font_banner}`}
                    alt="Template Showcase"
                    style={{ height: '13.3125rem', width: '20.25rem' }}
                    className="object-contain rounded"
                />
            </Container.Item>
            <Container.Item shrink={1}>
                <p className="text-base" style={{ color: '#0017E1' }}>
                    <span className="flex items-center gap-1">
                    <Zap className="w-5 h-5" />
                        {__("Google Fonts / Icons Font", "ultimate_vc")}
                    </span>
                </p>
                <div className="">
                    <Title
                        description=""
                        icon={null}
                        iconPosition="right"
                        className=""
                        size="md"
                        tag="h3"
                        title={__("Access 360 Versatile Fonts With All Ultimate Elements", "ultimate_vc")}
                    />
                </div>
                <p className="text-sm font-medium text-text-tertiary m-0  mt-2" style={{ maxWidth: '23rem' }}>
                    {__(
                        "Easily use custom google fonts within WPBakery using the built-in Google Font Manager.",
                        "ultimate_vc"
                    )}
                </p>
                {settings?.map((setting, index) => {
                    return (
                        <div
                            key={index}
                            className="flex items-center gap-2"
                            style={{ paddingTop: '1.5rem', maxWidth: '9rem' }}
                        >
                            <Link
                                to={routes.settings.path}
                                onClick={(e) => handleTabRedirect(e, setting.tab)}
                            >
                                <Button
                                    className="w-full mt-6 uavc-remove-ring"
                                    icon={null}
                                    iconPosition="left"
                                    size="md"
                                    variant="secondary"
                                >
                                    {__('Check Font List', 'ultimate_vc')}
                                </Button>
                            </Link>
                        </div>
                    );
                })}
            </Container.Item>
        </Container>
    )
}

export default ElementsFont
